<template>
  <div class="carousel_wrap">
    <el-carousel height="43vw" loop arrow="never" class="hidden-xs-only" pause-on-hover="false"
                 :interval="haveVideo ? 0 : 5000" :autoplay="!haveVideo" @change="handleCarouselChange">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <div class="slide-box" @click="goDetail(item.title)">
          <video v-if="isVideo(item)" :ref="'video-' + index" :src="item.imageUrl" class="video_item" loop muted playsinline />
          <img v-else :src="item.imageUrl" alt="" class="img_item" />
        </div>
      </el-carousel-item>
    </el-carousel>

    <el-carousel height="46vw" loop arrow="never" class="hidden-sm-and-up" pause-on-hover="false"
                 :interval="haveVideo ? 0 : 5000" :autoplay="!haveVideo" @change="handleCarouselChangeMobile">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <div class="slide-box" @click="goDetail(item.title)">
          <video v-if="isVideo(item)" :ref="'video-mobile-' + index" :src="item.imageUrl" class="video_item" loop muted playsinline />
          <img v-else :src="item.imageUrl" alt="" class="img_item" />
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { getHomeBanner } from '../../api/system'

export default {
  data() {
    return {
      imgList: [],
      haveVideo: false,
      currentIndex: 0,
      currentMobileIndex: 0
    }
  },
  methods: {
    // 判断是否为视频
    isVideo(item) {
      if (!item || !item.imageUrl) return false
      const url = item.imageUrl.toLowerCase()
      const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi']
      return videoExtensions.some(ext => url.endsWith(ext))
    },

    // 检查是否包含视频
    checkHaveVideo() {
      this.haveVideo = this.imgList.some(item => this.isVideo(item))
    },

    // 桌面端轮播切换事件
    handleCarouselChange(index) {
      this.currentIndex = index
      this.playCurrentVideo(index, 'video-')
    },

    // 移动端轮播切换事件
    handleCarouselChangeMobile(index) {
      this.currentMobileIndex = index
      this.playCurrentVideo(index, 'video-mobile-')
    },

    // 播放当前视频
    playCurrentVideo(index, refPrefix) {
      this.$nextTick(() => {
        // 暂停所有视频
        this.imgList.forEach((item, i) => {
          const videoRef = this.$refs[refPrefix + i]
          if (videoRef && videoRef[0]) {
            videoRef[0].pause()
          }
        })

        // 播放当前视频
        const currentItem = this.imgList[index]
        if (this.isVideo(currentItem)) {
          const videoRef = this.$refs[refPrefix + index]
          if (videoRef && videoRef[0]) {
            videoRef[0].currentTime = 0
            videoRef[0].play().catch(err => {
              console.log('视频播放失败:', err)
            })
          }
        }
      })
    },

    async getHomeBannerFunc() {
      const res = await getHomeBanner()
      if (res.data) {
        this.imgList = res.data.data || res.data
        this.checkHaveVideo()

        // 初始化时播放第一个视频（如果是视频）
        this.$nextTick(() => {
          this.playCurrentVideo(0, 'video-')
          this.playCurrentVideo(0, 'video-mobile-')
        })
      }
    },
    goDetail(productNo) {
      if (productNo !== ''){
        this.$router.push('/production/detail?productNo=' + productNo)
      }
    }
  },
  mounted() {
    this.getHomeBannerFunc()
  }
}
</script>

<style lang="scss" scoped>
.carousel_wrap {
  position: relative;
  .el-carousel__item {
    .slide-box{
      width:100%;
      height:100%;
      cursor:pointer;
      img,video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .video_item {
    display: block;
  }

  // 有视频时显示箭头
  ::v-deep .el-carousel__arrow {
    background-color: rgba(0, 0, 0, 0.5);

    &:hover {
      background-color: rgba(0, 0, 0, 0.7);
    }
  }
}
// 轮播小圆点整体按钮高度加大
::v-deep .el-carousel__button {
  height:16px !important;
  width:16px !important;
  border-radius:50%;
}
// 选中拉长
::v-deep .el-carousel__indicator.is-active .el-carousel__button {
  width:32px !important;
  border-radius:7px;
}

// 移动端单独再放大
@media screen and (max-width:768px){
  ::v-deep .el-carousel__button {
    height:14px !important;
    width:14px !important;
    border-radius:50%;
  }
  ::v-deep .el-carousel__indicator.is-active .el-carousel__button {
    width:28px !important;
    border-radius:7px;
  }
}

</style>